import { Component } from '@angular/core';
import { ToolingStepBaseComponent } from '../tooling-step-base.component';
import { RotecFormGroupConfigV2, FormsModuleV2 } from '@schenck/rotec-components';
import { ToolingTaskUpsertModel } from '../../upsert-tooling-task-wizard.component';

@Component({
  selector: 'ma-tooling-scheduling-step',
  templateUrl: './scheduling-step.component.html',
  imports: [FormsModuleV2],
})
export class ToolingSchedulingStepComponent extends ToolingStepBaseComponent {
  public schedulingFields: RotecFormGroupConfigV2<ToolingTaskUpsertModel> = [
    { key: 'id' },
    { key: 'scheduling' },
    { key: 'dueDate' },
    {
      type: <any>'scheduling',
      key: <any>'__scheduling',
      props: {},
    },
    {
      type: <any>'alarm',
      key: 'alarm',
    },
  ];
}
